
export enum CulturalLeadershipCatchupStatus {
    Overdue,
    Due,
    OnTime,
    Unscheduled,
}
